import { ModalProps } from "antd/lib/modal/Modal";
import { Modal, Spin } from "antd";
import React, { useContext } from "react";
import { getWordCloud } from "../../../../../../service/discuss";
import useRequest from "../../../../../../utils/useRequest";
import { CourseContext } from "../../../../Store";
import WordCloud from "../../../../../Evaluate/Components/WordCloud";

interface Props extends ModalProps {
    uuid: string;
    onCancel: () => void;
}

const Index = ({ uuid, onCancel, ...props }: Props) => {
    const { course } = useContext(CourseContext);
    const { courseSeq, courseNo, batchNo } = course;

    const [data, { loading: getLoading }] = useRequest(
        () => getWordCloud({ uuid, courseSeq, courseNo, batchNo: batchNo! }),
        {},
        [uuid]
    );

    return (
        <Modal
            {...props}
            footer={null}
            width={800}
            onCancel={onCancel}
            centered
            title="词云">
            <Spin spinning={[getLoading].some(i => i)}>
                {data && <WordCloud data={data || []} />}
            </Spin>
        </Modal>
    );
};
export default Index;
